//import { UUID } from './clientUUID';
import { Query } from '@/_core/cqrs/types/queries';
import { queryExecutor } from '@/_core/cqrs';
import { createDebugger } from '@/_core/utils/debug';
const debug = createDebugger('utils:serverSideUUID');

class UniqueGuidIdListQuery extends Query<string[]> {
    constructor(public CountOfIds: number) {
        super('UniqueGuidIdListQuery');
    }
}

interface IUniqueIdGenerator {
    create(): Promise<string>;
}

class ServerSideUniqueIdGenerator implements IUniqueIdGenerator {
    private ids: string[] = [];
    private countToGet: number;
    private countWhenGetNext: number;
    private isFetching: boolean = false;

    constructor(countToGet: number = 50, countWhenGetNext: number = 3) {
        this.countToGet = countToGet;
        this.countWhenGetNext = countWhenGetNext;
        this.ids = [];

        //this.fetchIds();
    }

    public async create(): Promise<string> {
        debug('ServerSideUniqueIdGenerator.create start');
        if (this.ids.length < this.countWhenGetNext && !this.isFetching) {
            await this.fetchIds();
        }

        if (this.ids.length == 0) {
            await this.fetchIds();
        }

        const currentId = this.ids.pop();
        debug('ServerSideUniqueIdGenerator.create end', currentId);
        return currentId;
    }

    private fetchIds = async () => {
        this.isFetching = true;
        const ids = await queryExecutor.executeQuery(new UniqueGuidIdListQuery(this.countToGet));
        this.ids = this.ids.concat(ids);
        this.isFetching = false;
    };
}

export const uuid = new ServerSideUniqueIdGenerator();
